// Copyright (c) 2025 Quantellia LLC
// All Rights Reserved
// console.log('main.js executed from:', document.currentScript?.src || 'unknown source');
// console.log('main.js executed:', new Error().stack);

// Load the default config, and modify it for a specific customer
// import {ChatConfig} from "./js/utils/chatconfig.js"

// imports instead of links so that webpack works correctly 
// import './css/style.css'; // TODO need a config mechanism that dynamically loads a substitute for this (e.g. gobot1.css) based on the config file
import './css/gobot1.css';
// import './css/cdd-feature.css';
// import './css/jumpin-feature.css';
import './css/node-editor.css';
import './css/loading-animation.css';

import $ from 'jquery';
// import * as d3 from 'd3'; // no longer used

// These are commented out because they are now conditionally loaded
// by webpack based on the productfeatures.config.js file
// import './js/features/cddjs/cddinvis.js';
// import './js/features/cddjs/grapher.js';
// import './js/features/cddjs/importexport.js';
// import {showImportExport} from "./js/features/cddjs/importexport.js";
// import {displayCDD,
//    initializeCDDDiagramSystem, getMyOptions,showCDDBox,
//    CDDRequest, processCDDMessage, hideCDDBox,
//    fitNetwork,
//   redrawNetwork,
//   showCDDThinkingAnimation,
//   setUpEventHandlers, handleCDDFromDICopilot
//   } from "./js/features/cddjs/grapher.js";
//import * as cddTextFeature from './js/features/cddjs/cddtextinit.js';

import './test/testing.js';
// import productFeatures from './productfeatures.config.js';

import {switchPrompt,initAB} from "./js/features/promptab/promptabcore.js";

import { countTokensInArrayOfObjects, sendMessageForStreamingResponse,sendMessageAndGetResponse } from './js/utils/streamingchatgpt.js';

import {userSessionIdentifier, sendSlackMessage, 
  readFromFile, USE_SLACKBOT,
  appendMessage, sharedState, slackAndConsole, displayError 
} from "./js/shared.js";

import {getMyOptions} from "./js/features/cddjs/grapher.js";

import loadFeatures from './js/features/featureloader.js';

// Ensure that we've imported the chatconfig.js module before startUp runs
// This is necessary because the chatconfig.js module is loaded asynchronously
// and we need to ensure that it's loaded before we call startUp
// import('./js/utils/chatconfig.js');
import {ChatConfig, chatConfigInitializationPromise} from "./js/utils/chatconfig.js";

await chatConfigInitializationPromise;

console.log("ChatConfig is ready:", ChatConfig);

// Globals, which need to be accessed by functions called from other modules, so they can't
// be scoped within the $(document).ready
// TODO move to config file

// TODO needs to move to config: a default ID which is then read here and overwritten
// when we set up the custom per-client channel

var errorString;

$(document).ready(async function () {
  const chatBox = $("#chat-box");
  const userInput = $("#user-input");
  // const toggleBtn = $("#toggle-btn");
  const sendBtn = $("#send-btn");

  // ChatConfig = loadCustomerConfig( ChatConfig );

  var systemPrompt = ChatConfig.systemPrompt; // Will hold the currently selected prompt

  var scoreArray = []; // Array of scores for each knowledge base element
  const TEST400ERROR = false; // Used for code to test for 400 errors
  const EXPERTISEPREFIX =
    "Please use this expertise in answering the user's question: ";

  //VENDOR_SLACK_TRACE = "slack"; // Set to a string if we want to send to quantellia's slack 
  // const PINECONE_ENVIRONMENT = "asia-southeast1-gcp-free";
  // TODO all of these need to go to a config file
  const PINECONE_INDEX = "canopy--document-uploader-2534829.svc"; // TODO needs a pinecone DB
  const PINECONE_TOKENLENGTH = 1536; // number of real numbers in the vector in our pinecone database
  const NUMBEROFEXPERTISECHUNKS = 4; // Max amount of expertise chunks to retrieve

  // Create empty messages list to store chat history 
  // var messages = [];

  // Constants to handle situation where this code is 
  // focusing on a particular user (for which we may have conversationID and/or userID)
  const PERSONALIZE = false;
  const TEST_UID = "999";
  const TEST_CID = "999";

  var myOptions = getMyOptions();

  var intakeInformation = {};
  var firstStartup = true;
  var graphTestingMode = false; // Opens the CDD window without having to type /cdd ***

  var CDDShowingOnScreen = false; // When this flag is set, we request a CDD at every user interaction.

  // Initialize DICopilot with a message history so that we don't have to pre-populate the chat window in advance of the CDD, for testing purposes
  const TESTDICopilotCDD = false;
  const SKIP_INTAKE_ON_TESTING = true; // Set to true to skip obtaining the bubble intake information when testing outside of bubble

  /////////////////////////////
  // initialization - mainline code starts here
  /////////////////////////////

  // When user clicks the Send button
  sendBtn.click(async function () {
    if (userInput.val().trim().length > 0) {
      sharedState.globalUserMessage = userInput.val();
      userInput.val("");

      // Check to see if the user's message isn't something that goes to chat, but instead is
      // a back-end ("slash") command.  This functino returns true if it handled the parsing for us
      // Note that slash commands don't initiate a call to the LLM at all.  If we need to do a LLM call in response to a slash
      // command, we need to be caction about how things are handled here, specifically the sharedState.globalUserMessage
      // needs to get the right value
      var slashHandled = await handleSlashCommand(sharedState.globalUserMessage);
      if (!slashHandled) {
        if (!ChatConfig.TESTINGSKIPLLMINVOCATION) sendMessageAndGetResponse(sharedState.globalUserMessage);
        else {
          var testingMessage = "TESTING SO NO KB ACCESS";
          var botMsg = '<div class="chat-message bot-message"><div class="message-content">' + testingMessage + '</div></div>';
          $("#chat-box").append(botMsg);
          // Scroll to the bottom of the chat window
          chatBox.scrollTop(chatBox[0].scrollHeight);
        }
      }
    }
  });

  // When user presses Enter key
  userInput.keypress(function (event) {
    if (event.which == 13) {
      if (USE_SLACKBOT && window.isJumpinCommand) {
        // Handle the jumpin command differently
        //alert('Handling /jumpin command in a special way!');
        window.isJumpinCommand = false; // Reset the flag
        // TODO create flags so that we're in /jumpin mode
        // until a /jumpout
      } else {
        sendBtn.click();
      }
      sendBtn.click();
    }
  });

  // When user clicks the Save button
  $("#save-btn").click(function () {
    var chatResponse = putChat("cid", "this is the test chat");
  });


  // Helper functions for handleExportConvo

  // TODO web socket should be in a config variable and updated
  // to be something different for server deployment

  //const socket = new WebSocket('ws://localhost:8080'); // Adjust the WebSocket URL if needed

  // socket.onopen = () => {
  //   console.log('Connected to the WebSocket server');
  // };

  // socket.onmessage = (event) => {
  //   const data = JSON.parse(event.data);
  //   if (data.command == '/exportconvo') {
  //     handleExportConvo(data.user_name, data.text);
  //   }
  // };

  // socket.onclose = (event) => {
  // console.log('Disconnected from the WebSocket server');
  // };

  // socket.onerror = (error) => {
  // console.error('WebSocket error:', error);
  // };

  //
  // Handle runtime commands (used only for testing atm)
  //
  async function handleSlashCommand(inputString) {
    if (typeof inputString !== 'string' || inputString.length === 0) {
      return false;
    }

    let element;
    if (inputString[0] === '/') {
      const commands = ["/cdd", "/nocdd",
        "/vconfig", "/vconfigoff", "/democdd",
        "/rw", "/help", "/fit", "/makecdd", "/redraw", "/ts"]; // Add more commands here if needed

      // Grab just the first word, in case they type more than just /command
      const command = inputString.split(' ')[0];
      if (commands.includes(command)) {
        // Call different functions based on the command
        switch (command) {
          case "/vconfig":
            element = document.querySelector('div.vis-configuration-wrapper');
            element.style.display = "block";
            break;
          case "/vconfigoff":
            element = document.querySelector('div.vis-configuration-wrapper');
            element.style.display = "none";
            break;
          case "/cdd":
            CDDShowingOnScreen = true; // Start requesting the CDD every time now
            await showCDDBox();
            // Because the chatbox changes in proportion when the CDD box
            // appeears, it may no longer be scrolled to the bottom. This makes it do
            // that
            chatBox.scrollTop(chatBox.prop("scrollHeight"));
            await initializeCDDDiagramSystem();
            break;
          case "/nocdd":
            CDDShowingOnScreen = false; // Stop requesting the CDD every time 
            hideCDDBox();
            break;
          case "/democdd":
            // if (CDDShowingOnScreen) showDemoCDD("easeOutQuart", hardCodedCDD1);
            if (CDDShowingOnScreen) {
              displayCDD("easeOutQuart", cddTextFeature.hardCodedCDDWithFormattedLabels);
            }
            else alert("please type /cdd first");
            break;
          case "/rw":
            if (CDDShowingOnScreen) showImportExport();
            else alert("please type /cdd first");
            break;
          case "/ts": // Test decision model scaffold
            testDIScaffold();
            //alert("testing model scaffold");
            break;
          case "/makecdd":
            showCDDBox(); // Open up the CDD box while we're querying the LLM to get the contents
            await askDICopilotToCreateCDD(); // TODO but the code to handle the CDD is in sendMessageAndGetResponse, so I think this isn't designed right
            // Maybe it should just set up the message queue?  Because sendMessageAndGetResponse will get called by its parent.
            // START HERE need to trace this through and fix the integration
            CDDShowingOnScreen = true;
            // if (!CDDShowingOnScreen) handleSlashCommand("/cdd"); // Open the CDD box <= Moving this to the sendMessageAndGetResponse function
            break;
          case "/help":
            alert("Commands are: " + commands.join(", "));
            break;
          case "/fit":
            fitNetwork();
            break;
          case "/redraw":
            redrawNetwork();
            setUpEventHandlers();
            break;
          // case "/nocdd":
          //   startFunction();
          //   break;
          // Add more cases for other commands here if needed
          default:
            break;
        }
        return true;
      } else {
        // If it's a / command, but not recognized, return false
        return false;
      }
    } else {
      // If it's not a / command, return false
      return false;
    }
  }

  // Initialization code ends here. Now start everything up
  // XXX REM - this function does not wait so something is not right. 
  // Occasionally an error is thrown in the browser console: Uncaught (in promise) Error: Could not establish connection. Receiving end does not exist.
  console.log("Starting mainline code");

  // Load and initialize features dynamically based on the product configuration
  const loadedFeatures = {};

  // START HERE: when startup runs, the version of ChatConfig that is passed in is the default version, not the one that has been customized, and I don't know why


  await startUp();

  sendSlackMessage(`${userSessionIdentifier} chat started\n${window.location.href}`);

  // Focus the input field when the page loads
  userInput.focus();

  /////////////////////////////
  // END OF MAINLINE CODE
  /////////////////////////////

  // Function to handle the 401 Unauthorized error
  function handleUnauthorized() {
    console.error('User is not logged in. Access denied.');
    const errorContainer = document.getElementById('error-container');
    errorContainer.innerHTML = 'Unauthorized: You are not logged in.';
    errorContainer.style.color = 'red';
    const unauthorizedError = new Error('Unauthorized');
    unauthorizedError.status = 401;
    throw new Error(unauthorizedError);
  }

  //
  // Do everything required when we start up the chat
  //
  async function startUp() {
    sharedState.messages.length = 0; // Clear messages
    console.log("In startup")

    // Things we only need to do on first startup
    if (firstStartup) {

    
      ////////////////////////////
      // Load product features
      // (async () => {
      // }) for matching
      try {
        const features = await loadFeatures(false);
        Object.assign(loadedFeatures, features);
        console.log("All client-side features loaded successfully.");

        // Example: Invoking a function in the `helloWorld` feature
        // document.addEventListener('DOMContentLoaded', () => {
          // }) for matching
        // Use this as an example of how to call a function from a loaded feature
        // Note that it might make sense to do all the testing for functions at the top of 
        // a feature file, to simplify subsequent code
        if (loadedFeatures.helloWorld && loadedFeatures.helloWorld.sayHello) {
          loadedFeatures.helloWorld.sayHello();

        } else {
          console.log("Function `sayHello` is not available in `helloWorld`.");
        }
      } catch (error) {
        console.error("Error loading client-side features:", error);
      }
      // ({{ // for matching
      // }})();

      ////////////////////////////
      

      ////////////////////////////
      // Initialize conditional features
      // Only initialize A/B prompt testing if the feature is enabled
      if (loadedFeatures.promptAB) initAB();

      if (loadedFeatures.jumpin) {
        if (loadedFeatures.jumpin.jumpInInit)
          loadedFeatures.jumpin.jumpInInit();
        else {
          console.error("Function `jumpInInit` is not available in `jumpin`.");
        }
      }

      ////////////////////////////

      // obtain configuration parameters for context of the chat
      //await getConfigParams(ChatConfig); // TODO we probably can eliminate the getConfigParams function: we have other
      // config setting stuff
      systemPrompt = ChatConfig.systemPrompt;
      ////////////////////////////

      // User is not logged in, show 401 Unauthorized error
      // if (!await BubbleInterface.isLoggedin(ChatConfig.uid) ){ handleUnauthorized(); }

      if (SKIP_INTAKE_ON_TESTING) {
        intakeInformation = "Please make one of the first things you do to ask my name and then use my name in our interactions";
      }
      else
      {
        intakeInformation = "";
        // // Obtain user's intake information and add it to the context
        // //intakeInformation = await getIntakeInformation(ChatConfig);
        // sendSlackMessage(
        //   `${userSessionIdentifier} user-specific intake information: "${intakeInformation}"`
        // );
      }

    } else {
      // Things we only need to do on second and subsequent startups,
      // TODO might want to clear the input window
      switchPrompt();
    }

    // Initialize the chat history with the initial system prompt
    // messages.push({ role: "system", content: intakeInformation });
    sharedState.messages.push({ role: "user", content: intakeInformation });
    sharedState.messages.push({ role: "system", content: systemPrompt });

    // Start out DICopilot with a set of initial messages so I don't have to keep typing them for testing of CDD integration
    if (TESTDICopilotCDD) {
      var LLMMessagesForTesting = getTestMessage(); // Obtain a message history good to use for testing
      for (const message of LLMMessagesForTesting) {
        await appendMessage(message.content, message.role);
        sharedState.messages.push(message);
      }
    }

    // If we're trying to test the 400 error, then push the prompt onto the messages queue, just to build up the token count to drive the error
    if (TEST400ERROR) {
      sharedState.messages.push({ role: "system", content: systemPrompt });
      sharedState.messages.push({ role: "system", content: systemPrompt });
      const messageSize = countTokensInArrayOfObjects(sharedState.messages);
      console.log(
        "Starting 400 error testing with messageSize: " + messageSize
      );
    }

    // TODO needs to be debugged and implemented
    //obtainHistoricalChat(ChatConfig.cid);

    // Send initial messages - this is before there is any user interaction
    if (ChatConfig.streamingMode && !ChatConfig.TESTINGSKIPLLMINVOCATION)
      await sendMessageForStreamingResponse(sharedState.messages);
    else await sendMessageForNonStreamingResponse(sharedState.messages);

    // TODO duplicate this in the other places we do this
    // If we are in CDD mode, then invisibly after we respond to the latest text, request a CDD 
    // and display it.  
    //if (askForCDDMode) await CDDRequest(messages);

    // For testing, open the model box at the start
    if (graphTestingMode)
      handleSlashCommand("/cdd");

    sharedState.totalTokensInMessages = countTokensInArrayOfObjects(sharedState.messages);

    firstStartup = false;
  }

  //
  // Use the user's recent messages to do a KB lookup
  //
  async function getEmbeddingsText(userMessage) {

    // Convert the user message into a vector embedding
    const userMessageEmbeddingVector = await getUserMessageEmbeddingFromOpenAI(userMessage);

    try {
      // Get the vector embeddings from Pinecone
      const pineConeVectorString = await fetchVectorEmbeddings(
        userMessageEmbeddingVector,
        PINECONE_INDEX,
        NUMBEROFEXPERTISECHUNKS
      );

      // TODO do parse check first for robustness here
      let pineConeVectorArray = JSON.parse(pineConeVectorString);

      if (ChatConfig.KBLOOKUP && ChatConfig.KBTRACKING) {
        // Get just the ID fields of the KB data
        //
        // TODO needs to be made robust to misformed and missing data
        //
        const matches = pineConeVectorArray.matches;
        // const idArray = matches.map((entry) => entry.id);
        const idArray = matches.map((entry) => entry.metadata.text);
        const scoreArray = matches.map((entry) => entry.score);
        const result = scoreArray.map((item, index) => ({ score: item, knowledge: idArray[index] }));

        //sendSlackMessage("For KB tracking, here's the data we got from pinecone, before filtering: " + JSON.stringify(result));
      }

      // Convert the vectors into a big string containing only the "id" entries,
      // each preceded by the expertise prefix.  
      // Also filter the vectors to the top matches, and only those with a high enough score

      let matchesList = pineConeVectorArray.matches.filter((entry) => entry.score >= ChatConfig.score);

      if (matchesList.length == 0) {
        if (ChatConfig.KBTRACKING) {
          const string = "No expertise found with score over threshold of " + ChatConfig.score + ".";
          console.log(string);
          sendSlackMessage(string);
        }
        return "";
      } else {
        // const idArray = matchesList.map((entry) => entry.id);
        const idArray = matchesList.map((entry) => entry.metadata.text);
        scoreArray = matchesList.map((entry) => entry.score);
        var concatenatedIds = idArray.join("\n" + EXPERTISEPREFIX);
        concatenatedIds = EXPERTISEPREFIX + concatenatedIds;
      }
    } catch (error) {
      errorString = `Error while fetching embeddings: ${error.responseText}`;
      slackAndConsole(errorString);
    }
  }

  // Obtain the closest matching vector embeddings, appropriately filtered, from Pinecone
  function fetchVectorEmbeddings(queryVector, indexName, topK = 2) {
    const proxyURL = "pineconeproxy.php";

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    var valueToReturn;

    const body =
      "data=" +
      JSON.stringify({
        vector: queryVector,
        top_k: topK,
        threshold: ChatConfig.score,
        includeMetadata: true,
        includeValues: true,
        namespace: "",
      });

    return new Promise((resolve, reject) => {
      $.ajax({
        //url: pineconeURL,
        url: proxyURL,
        type: "POST",
        headers: headers,
        //method: "POST",
        data: body,
        contentType: "application/x-www-form-urlencoded",
        success: function (response) {
          resolve(response);
          //console.log("Success");
        },
        error: function (error) {
          errorString = "Error fetching vector embeddings:" + error.responseText;
          displayError(errorString);
          console.error(errorString);
          reject(errorString);
        },
      });
    });
  }


  // Remove redundant knowledge base information from the messages history array
  // TODO remove magic constant
  function removeRedundantSubstrings(array, N = 6) {
    // 	In this updated implementation, the removeRedundantContent function keeps track of the encountered content strings using the contentMap object. Each entry in the map stores the count of occurrences and the index of the first occurrence.

    // It then iterates over the contentMap and removes the subsequent occurrences of redundant content strings that have at least N-word matches anywhere in the array
    // Test data:
    // array = [
    //   { role: 'system', content: 'You are the chatbot of Quantellia, Inc. expertise: yup that\'s correct awesome'  },
    //   { role: 'assistant', content: 'expertise: this is terrific'},
    //   { role: 'user', content: 'I am considering discontinuing a product. expertise: yup that\'s correct awesome' },
    //   { role: 'assistant', content: 'Discontinuing a product can be a difficult decision. expertise: this is terrific' },
    // ];
    const contentMap = {};

    // Step 1: Find redundant sequences of matching words starting with the label that we use to identify expertise
    for (let i = 0; i < array.length; i++) {
      const content = array[i].content;
      const sequences = content.match(
        new RegExp(
          `\\b${EXPERTISEPREFIX}[\\s\\S]+?(?=\\b${EXPERTISEPREFIX}|$)`,
          "g"
        )
      );

      if (sequences) {
        for (const sequence of sequences) {
          if (contentMap[sequence]) {
            contentMap[sequence].count++;
            contentMap[sequence].indices.push(i);
          } else {
            contentMap[sequence] = { count: 1, indices: [i] };
          }
        }
      }
    }

    // Step 2: Remove redundant sequences of matching words starting with the label that we use to identify expertise
    for (const sequence in contentMap) {
      if (contentMap[sequence].count > 1) {
        const indices = contentMap[sequence].indices;
        for (const index of indices) {
          array[index].content = array[index].content.replace(sequence, "");
        }
      }
    }

    // Step 3: Remove array entries with null content
    array = array.filter((entry) => entry.content !== "");

    return array;
  }

  async function configurePrompts(config, promptID, syspromptID) {
    let prompt = syspromptID != null ? syspromptID : "promptA";
    try {
      config.systemPrompt = await readFromFile("./data/systemPrompts/" + prompt + ".txt");
    }
    catch (error) {
      config.systemPrompt = !(typeof _systemPromptB === 'undefined') ? _systemPromptB : null;
    }

    if (promptID == null) return;
    try {
      prompt = await readFromFile("./data/autobotPrompts/" + promptID + ".txt");
    }
    catch (error) {
      prompt = !(typeof _systemPromptAutobot === 'undefined') ? _systemPromptAutobot : null;
    }
    finally {
      if (promptID && prompt != null) {
        config.autobotMessages.push({ role: "system", content: prompt });
        config.autobot = true;
      } else {
        config.autobot = false;
      }
    }
  }

  async function getConfigParams(config) {
    //
    // As a precursor to obtaining the historical chat information from a user,
    // set the cid and/or UID based on the test data if we're not embedded
    //
    let cid = TEST_CID;
    let uid = TEST_UID;
    let personalize;
    let temp;
    let logs;
    let score;
    let autobot;
    let system;

    console.log(PERSONALIZE ? "EMBEDDED mode" : "");
    if (PERSONALIZE) {
      // get user and chat ids from HTML doc
      cid = $("#HTMLchat").attr("cid");
      uid = $("#HTMLchat").attr("uid");
      if (cid == undefined || uid == undefined) {
        console.error("cid or uid is undefined!");
        return ""; // should throw an exception and log
      }
    } else {
      // Assuming the URL is: https://example.com/?name=John&age=25

      // Get the current URL
      const url = new URL(window.location.href);

      // Get the search parameters from the URL
      const searchParams = new URLSearchParams(url.search);

      // Extract values from the URL arguments and store them in variables
      cid = searchParams.get("cid");
      uid = searchParams.get("uid");
      personalize = searchParams.get("personalize");
      temp = searchParams.get("temp");
      score = searchParams.get("score");
      autobot = searchParams.get("autobot");
      system = searchParams.get("system");
      logs = searchParams.get("logs");
    }

    //update config object
    config.uid = uid;
    config.cid = cid;
    config.personalize = personalize ?? config.personalize;
    config.temperature = parseFloat(temp ?? config.temperature);
    config.score = parseFloat(score ?? config.score);
    config.logs = logs ?? config.logs;
    await configurePrompts(config, autobot, system);

    console.log(config);

    //update session identifier used in logging
    //ASSUMING there is a username:NAME name/val pair in the personalize string
    const user = config.personalize ? config.personalize.match(/username:([^&,]+)/) : null;
    // TODO I commented the line below out because the module where shared.js exposes userSessionIdentifier only
    // exposes a setter not a getter, and that needs to be fixed.  But we don't use the cid functionality atm so that's ok
    //userSessionIdentifier = `(cid:${cid} ${user ? user[0] : ""})`;
  }




  ///
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  //// This version produces the text one token at a time, in a series
  // Function to send an Ajax request
  async function sendAjaxRequestForAnimatedCompletion(
    url,
    method,
    data,
    headers,
    tokensCount,
    localMessages
  ) {
    // Throttle responses to 4 per second
    await sleep(500); // Delay before starting the response

    // TODO need to change this entire function to handle streaming data instead of how it's written now
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            console.log(
              "Just received successful response in sendAjaxRequestForAnimatedCompletion: " +
                xhr.responseText
            );
            var response = JSON.parse(xhr.responseText);
            if (response.choices && response.choices.length > 0) {
              resolve(response.choices[0]);
            } else {
              reject(new Error("No completion available."));
            }
          } else {
            reject(
              new Error("Error in animation completion response: " + xhr.status)
            );
          }
        }
      };
      xhr.open(method, url, true);
      for (var key in headers) {
        xhr.setRequestHeader(key, headers[key]);
      }

      data.messages = localMessages; // Ensure that the recursive version of messages is the request
      xhr.send(JSON.stringify(data));
    });
  }
  

  // Convert the user's message into a vector embedding. This will be used to find the closest matching knowledge base text
  //
  async function getUserMessageEmbeddingFromOpenAI(queryString) {
    try {
      //const textQuery = { input: queryString};
      const response = await fetch("https://api.openai.com/v1/embeddings", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${ChatConfig.QUANTELLIA_OPENAI_TOKEN}`, // This is Quantellia's API key
        },
        body: JSON.stringify({
          input: queryString,
          model: "text-embedding-ada-002",
        }),
      });

      const data = await response.json();
      const embedding = data.data[0].embedding;
      // console.log('Embeddings response starts with:', embedding.slice(0,5));
      return embedding;
    } catch (error) {
      errorString =
        "Error fetching embeddings, returning a random string. Error is: " +
        error;
      //displayError( errorString );
      console.error(errorString);
      const randomEmbedding = Array.from({ length: PINECONE_TOKENLENGTH }, () =>
        Math.random()
      );
      return randomEmbedding;
    }
  }


  // Sends a message to the server and retrieves the response in one chunk - not streaming
  async function sendMessageForNonStreamingResponse(messages, codeInstructionsMessage = false) {
    // TODO this should go into config
    // TODO we should do summarization if needed based on this number

    const MAXTOKENSWHENREQUESTINGCDD = 1500; // TODO: WHAT TO DO if we go over token length here???  atm it fails on a json parse.

    if (ChatConfig.TESTINGSKIPLLMINVOCATION) {
      var testingMessage = "TESTING SO NO DICopilot";
      var botMsg = '<div class="chat-message bot-message"><div class="message-content">' + testingMessage + '</div></div>';
      $("#chat-box").append(botMsg);
      // Scroll to the bottom of the chat window
      chatBox.scrollTop(chatBox[0].scrollHeight);
    }
    else {
      $.ajax({
        //url: "https://api.openai.com/v1/chat/completions",
        url: ChatConfig.COMPLETION_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${ChatConfig.QUANTELLIA_OPENAI_TOKEN}`,
          //"Authorization": "Bearer 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"
        },
        method: "POST",
        data: JSON.stringify({
          'messages': sharedState.messages,
          model: 'gpt-3.5-turbo-16k',
          max_tokens: MAXTOKENSWHENREQUESTINGCDD,
          stream: false,
          temperature: ChatConfig.temperature,
          //context: contextConversationId,
          //n: 1,
          //stop: "\n"
        }),
        ////
        // NOTE: this success block is where we land after a new CDD is rendered
        ////
        success: function (response) {
          // TODO there's a long delay before this response comes back. Consider a loading animation
          // Extract the generated text from the response TODO: this should be more defensive.  I've seen it return without all these elements
          var choices = response.choices;
          if (!choices) {
            console.error('Bad choices returned from nonstreaming chat');
            return false;
          }
          var localmessages = choices[0]['message'];
          if (!localmessages) {
            console.error('Bad messages returned from nonstreaming chat');
            return false;
          }
          var chatMessage = localmessages['content'];

          // Add system message to the context TODO do we want to do this?  Don't we do this inside of handling the CDD from DICopilot?
          sharedState.messages.push({ "role": "assistant", "content": chatMessage });
          if (codeInstructionsMessage) {
            if (cddTextFeature.TESTING_STUB_DICOPILOT_CDD) chatMessage = cddTextFeature.DICOPILOT_TESTING_STUB_JSON;
            handleCDDFromDICopilot(chatMessage);

            // Now need to show the CDD box without changing the CDD to the default one

            // *** removing this because it shows the default CDD
            //handleSlashCommand("/cdd"); // Open the CDD box if it's not already opened
            //if (!CDDShowingOnScreen) handleSlashCommand("/cdd"); // Open the CDD box if it's not already opened
          }
          else {

            // TODO need to add summarization code here, as is in processStreamingResponse

            // Add the chatbot's message to the chat window
            chatMessage = chatMessage.replace(/\n/g, '<br>');

            // Note that this is a div, not a span, because it's the full message not just a piece of it, as we do
            // in the equivalent streaming code
            var botMsg = '<div class="chat-message bot-message"><div class="message-content">' + chatMessage + '</div></div>';
            // TODO update to this code, and also make this string not a magic constant (it's used in at least 3 places)
            // Sends a message to the server and retrieves the response
            // var botMsg = $(
            //   "#chat-box .chat-message.bot-message:last-child .message-content"
            // );


            //chatBox.append(botMsg);
            chatBox.append(botMsg);

            // Scroll to the bottom of the chat window
            chatBox.scrollTop(chatBox[0].scrollHeight);
          }
        },
        error: function (error) {
          console.error('Error sending nonstreaming message:' + error.responseText.toString()); // should throw an exception and log
        }
      });
    }
    userInput.val("");  // Clear user input
  }
});